export const FETCH_MODULE_URL = `${process.env.REACT_APP_API_URL}/modules`;
export const CREATE_MODULE_URL = `${process.env.REACT_APP_API_URL}/modules/create`;
export const UPDATE_MODULE_URL = `${process.env.REACT_APP_API_URL}/modules`;
export const DELETE_MODULE_URL = `${process.env.REACT_APP_API_URL}/modules`;
export const CREATE_BULK_MODULE_URL = `${process.env.REACT_APP_API_URL}/modules`;
